import React from 'react';
import { NavLink } from 'react-router-dom';

// Since this component is simple and static, there's no parent container for it.
const Head = (show) => {
  let mainClasses = [];

  if (show) {
    mainClasses.push('show');
  }

  return (
    <div className={"header home-header " + mainClasses.join(' ')}>
      <section className="header-textbox">
        <h5 className="header-title">Crowd safety-wear for kids</h5>
        <p className="header-para">Vizkidz provides an innovative way to help you safeguard your family, or any vulnerable person. For more information look below, or if you&#8216;re ready...</p>
        <NavLink to="/register">
          <button  className="header-btn">Register Free</button>
        </NavLink>
      </section>
    </div>
  );
};

export default Head;



// WEBPACK FOOTER //
// ./src/components/common/Head.js